import { GridRegistrationStatusEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { StatusDefinition } from '../status.model';
import { COMMON_REQUEST_STATUS_DEFINITIONS } from './common.status-definitions';

/** Netzanmeldung (`GridRegistration.state`). */
export const GRID_REGISTRATION_STATUS_DEFINITIONS: readonly StatusDefinition[] = [
  ...COMMON_REQUEST_STATUS_DEFINITIONS,
  // Nur Netzanmeldung: `CommissioningStatus` kennt diese Werte nicht.
  { value: GridRegistrationStatusEnum.Declined, defaultLabel: 'Abgelehnt', defaultColor: '#fd7e14' },
  {
    value: GridRegistrationStatusEnum.PlaceInServiceConfirmationRequest,
    defaultLabel: 'Warten auf Bestätigung durch den Kunden',
    defaultColor: '#71dde3'
  },
  {
    value: GridRegistrationStatusEnum.PlacedInServiceConfirmation,
    defaultLabel: 'Inbetriebsetzung bestätigt',
    defaultColor: '#71dde3'
  },
  {
    value: GridRegistrationStatusEnum.WaitingForCustomerFeedInOrder,
    defaultLabel: 'Bestellung des Einspeisemanagements ausstehend',
    defaultColor: '#71dde3'
  },
  {
    value: GridRegistrationStatusEnum.ConfiguringFeedInManagement,
    defaultLabel: 'Bereitstellung des Einspeisemanagements',
    defaultColor: '#71dde3'
  },
  {
    value: GridRegistrationStatusEnum.PendingAssignTechnician,
    defaultLabel: 'Installateur noch nicht zugewiesen',
    defaultColor: '#71dde3'
  },
  {
    value: GridRegistrationStatusEnum.NeedMeterChange,
    defaultLabel: 'Zählerwechsel notwendig',
    defaultColor: '#C3E88D'
  },
  { value: GridRegistrationStatusEnum.Expired, defaultLabel: 'Abgelaufen', defaultColor: '#C3E88D' },
  {
    value: GridRegistrationStatusEnum.CompletedPositioning,
    defaultLabel: 'Abrechnung abgeschlossen',
    defaultColor: '#e99aa6'
  }
];
